export default "__VITE_ASSET__BdPH7hmC__"